import styled from "styled-components";
const ColoredTitle = styled.h1`
  background: linear-gradient(90deg, #00ffa3 -1.07%, #714dff 21.84%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 61.2px;
`;

export default ColoredTitle;